import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "code-2hT3Q",
  "use": "code-2hT3Q-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"code-2hT3Q\"><path d=\"M16 18l6-6-6-6M8 6l-6 6 6 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol